import React from 'react'
import { useDispatch } from 'react-redux'
import { Switch as SwitchAntd } from 'antd'
import 'antd/dist/antd.css'

const Switch = ({ name, action, defaultChecked }) => {
    const dispatch = useDispatch()

    function onChangeSwitch(checked) {
        dispatch(action(Boolean(checked)))
    }

    return (
        <div className="switch__wrapper">
            <SwitchAntd defaultChecked={defaultChecked} onChange={onChangeSwitch} /> {name}
        </div>
    )
}

export default Switch
